import { FEATURE } from './package';

export const ORDER_BY = [
  { label: 'increase', value: 'increase' },
  { label: 'decrease', value: 'decrease' },
];

export const VOICE_CRITERIA_SORT = [
  { label: 'latestVoice', value: 'latest' },
  { label: 'mostPopular', value: 'popular' },
  { label: 'favorite', value: 'favorite' },
];

export const VOICE_OWNERSHIP = {
  VBEE: 'VBEE',
  PERSONAL: 'PERSONAL',
  COMMUNITY: 'COMMUNITY',
};

export const VOICE_LIBRARY = [
  { value: VOICE_OWNERSHIP.VBEE, label: 'vbeeVoice' },
  { value: VOICE_OWNERSHIP.PERSONAL, label: 'myVoice' },
  { value: VOICE_OWNERSHIP.COMMUNITY, label: 'communityVoice' },
];

export const GENDER = [
  { value: 'female', label: 'female' },
  { value: 'male', label: 'male' },
];

export const VOICE_TONE = [
  { label: 'low', value: 'low' },
  { label: 'middle', value: 'middle' },
  { label: 'hight', value: 'hight' },
];

export const VOICE_DOMAIN = [
  { label: 'review', value: 'review' },
  { label: 'hotTrend', value: 'trend' },
  { label: 'chronicle', value: 'chronicle' },
  { label: 'news', value: 'news' },
  { label: 'commentary', value: 'commentary' },
  { label: 'demonstration', value: 'demonstration' },
];

export const BREAK_TIME = [0.5, 1, 2, 3];

export const SPEED = [
  { value: 0.25, title: 'verySlow' },
  { value: 0.5, title: 'slow' },
  { value: 0.75, title: 'slower' },
  { value: 1, title: 'normal' },
  { value: 1.05, title: 'faster' },
  { value: 1.1, title: 'fast' },
  { value: 1.15, title: 'veryFast' },
];

export const AUDIO_TYPE = ['mp3', 'wav'];

export const BITRATE = [8, 16, 32, 64, 128];

export const DEFAULT_BREAK_TIME = 1;

export const DEFAULT_SPEED = 1;

export const DEFAULT_SYNTHESIS_REQUEST = {
  title: '',
  breakTime: 0.5,
  speed: 1,
  audioType: 'mp3',
  bitrate: 128,
  volume: 100,
  backgroundMusic: { volume: 80 },
  emphasis: 0,
  hasEmphasis: false,
  pitch: 'default',
};

export const REQUEST_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const AUDIO_FILE_FORMAT = ['mp3', 'wav'];

export const TEXT_FILE_FORMAT = ['docx', 'txt'];

export const LANGUAGE_CODE = { VIETNAMESE: 'vi-VN' };

export const MAX_TRY_LISTENING_CHARACTERS = 2000;

export const VOICE_PAGINATION_LIMIT = 10;

export const BREAK_TIME_REGEX = /[<]break\s+time[=]([0-9.]+)[s][/][>]/g;

export const BREAK_TIME_REGEX_WITH_DOUBLE_QUOTES =
  /[<]break\s+time[=]["]([0-9.]+)[s]["][/][>]/g;

export const MERGED_BREAK_TIME_REGEX =
  /[<]break\s+time[=]([0-9.]+)[s][/][>]|[<]break\s+time[=]["]([0-9.]+)[s]["][/][>]/g;

export const SPECIAL_CHARACTERS_REGEX = /[/\\:*?"<>|]/g;

export const TTS_ATTRIBUTE = {
  EMPHASIS: 'EMPHASIS',
  PITCH: 'PITCH',
  SPEED: 'SPEED',
  BREAK_TIME: 'BREAK_TIME',
};

export const VOICE_PROVIDER = {
  MICROSOFT: 'microsoft',
  GOOGLE: 'google',
  AMAZON: 'amazon',
  VBEE: 'vbee',
  VBEE_VOICE_CLONING: 'vbee-voice-cloning',
};

export const BREAK_LINE = '\n';

export const EMPHASIS_LEVEL = ['strong', 'moderate', 'reduced'];

export const PITCH = ['low', 'medium', 'default', 'hight'];

export const REGEX = {
  ADVANCE_TAG:
    /[<]break\s+time[=]["]([0-9.]+)[s]["][/][>]|[<]emphasis\s+level[=]["](?:strong|moderate|reduced)["][>]|[<][/]emphasis[>]|[<]prosody\s+rate[=]["](?:x-fast|fast|medium|slow|x-slow|(?:(\+|-)[0-9.]+%))["][>]|[<][/]prosody[>]/g,
  EMPHASIS_TAG:
    /[<]emphasis\s+level[=]["](?:strong|moderate|reduced)["][>]|[<][/]emphasis[>]|[<]prosody\s+rate[=]["](?:x-fast|fast|medium|slow|x-slow|(?:(\+|-)[0-9.]+%))["][>]|[<][/]prosody[>]/g,
  ADVANCE_BREAK_TIME_TAG: /[<]break\s+time[=]["]([0-9.]+)[s]["][/][>]/g,
};

export const VOICE_FEATURE = {
  EMPHASIS: 'emphasis',
};

export const VOICE_LEVEL = {
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM',
  MULTILINGUAL: 'multilingual',
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
  GEN2: 'GEN2',
};

export const ENGLISH_VOICE_CODES = [
  'en-US',
  'en-AU',
  'en-GB',
  'en-IN',
  'en-NZ',
  'en-ZA',
];

export const GLOBAL_VOICE_FEATURES = {
  GLOBAL: 'global-voice',
  STANDARD: 'standard-global-voice',
  BASIC: 'basic-global-voice',
  ADVANCED: 'advanced-global-voice',
  PREMIUM: 'premium-global-voice',
};

export const VIETNAM_VOICE_FEATURES = {
  STANDARD: 'standard-vietnam-voice',
  BASIC: 'basic-vietnam-voice',
  ADVANCED: 'advanced-vietnam-voice',
  PRO: 'pro-vietnam-voice',
  PREMIUM: 'premium-vietnam-voice',
};

export const OLD_VERSION_DUBBING_VOICE_CODES = [
  'hn_female_ngochuyen_full_48k-fhg',
  'sg_female_tuongvy_call_44k-fhg',
  'sg_female_thaotrinh_full_48k-fhg',
  'hn_female_maiphuong_vdts_48k-fhg',
  'sg_female_lantrinh_vdts_48k-fhg',
];

export const NON_VBEE_VOICE_PROVIDERS = ['google', 'amazon', 'microsoft'];

export const OUTPUT_AUDIO = [
  { type: 'mp3', feature: FEATURE.OUTPUT_MP3, featureDesc: 'outputMp3Desc' },
  { type: 'wav', feature: FEATURE.OUTPUT_WAV, featureDesc: 'outputWavDesc' },
];

export const DEFAULT_VOICE_CLONING_LIMIT_FOR_WHITELIST = 3;

export const COMMUNITY_VOICE = 'community-voice';

export const CLIENT_PAUSE = 'client-pause';

export const PRONUNCIATION = 'pronunciation';

export const BACKGROUND_MUSIC = 'background-music';

export const VOICE_CODE = 'voice-code';

export const SHOW_VOICES = 'show-voices';

export const VOICE_FEATURED_PAGINATION_LIMIT = 6;

export const VOICE_TRENDING_PAGINATION_LIMIT = 5;

export const VOICE_NEWEST_PAGINATION_LIMIT = 5;

export const VOICE_LOAD_MORE_PAGINATION_LIMIT = 20;
export const VOICE_LOAD_MORE_PAGINATION_LIMIT_TRENDING = 30;

export const SORT_VOICE_OPTIONS_COMMUNITY = [
  {
    label: 'mostGenerated',
    value: 'stats.totalCredits_desc',
  },
  {
    label: 'mostPopularV2',
    value: 'stats.totalUsers_desc',
  },
  {
    label: 'newestVoice',
    value: 'publishAt_desc',
  },
];

export const SORT_VOICE_OPTIONS_VBEE = [
  {
    label: 'featuredVoice',
    value: 'rank_asc,name_asc',
  },
  {
    label: 'fromAToZ',
    value: 'name_asc',
  },
  {
    label: 'fromZToA',
    value: 'name_desc',
  },
];

export const SORT_VOICE_OPTIONS_MY_VOICE = [
  {
    label: 'newestVoice',
    value: '_id_desc',
  },
  {
    label: 'fromAToZ',
    value: 'name_asc',
  },
  {
    label: 'fromZToA',
    value: 'name_desc',
  },
];

export const SORT_VOICE_OPTIONS_FAVOURITE = [
  {
    label: 'recentlyFavourited',
    value: 'createdAt_desc',
  },
  {
    label: 'fromAToZ',
    value: 'name_asc',
  },
  {
    label: 'fromZToA',
    value: 'name_desc',
  },
];

export const DEFAULT_RETENTION_DAYS = 30;
